var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-scramble"},[_c('h2',{style:({textAlign: 'left'})},[_vm._v(_vm._s(_vm.scramble))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.previewHTML)}})])}
var staticRenderFns = []

export { render, staticRenderFns }